import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { QueryState } from 'src/app/core/models/query.model';

//CONFIGURAZIONE PER ESTRARRE IL JSON DEL FORM
export const JSON_FORM_ENDPOINT = 'jsonForm';
export const JSON_FORM_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(JSON_FORM_ENDPOINT);


export const fileStateConfig: SignalStoreConfig<QueryState<any>> = {
    initState: {
      list: []
    }
  }


  export const formStateConfig: SignalStoreConfig<QueryState<any>> = {
    initState: {
      list: []
    }
  }



//CONFIGURAZIONE PER EFFETTUARE LE OPEZIONI DI CRUD SUI FILE
export const  CRUD_FILE_ENDPOINT = 'files';
export const  CRUD_FILE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CRUD_FILE_ENDPOINT);

//CONFIGURAZIONE PER EFFETTUARE LE OPEZIONI DI CRUD SUI FORM
export const  CRUD_FORM_ENDPOINT = 'forms';
export const  CRUD_FORM_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CRUD_FORM_ENDPOINT);

